/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import { Box, Modal, IconButton, Typography } from '@mui/material';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';

interface PreviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    content: string;
}

const TemplatePreview = ({ isOpen, onClose, content }: PreviewModalProps): JSX.Element => {
    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box sx={{ 
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '90%', 
                maxWidth: 700,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 2,
                outline: 'none',
                borderRadius: 2,
                height: '90%'
            }}>
                {/* Close Button */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography id="server-modal-title" sx={{ m: 0, p: 0, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }}>
                    Template Preview
                </Typography>
                    <IconButton onClick={onClose}>
                    <HugeiconsIcon
                                     icon={MultiplicationSignStrokeStandard}
                                     size={24}
                                     color="currentcolor"
                                     strokeWidth={0.5}
                                   /> 
								   
								   
                    </IconButton>
                </Box>
                
                {/* Iframe for HTML Content */}
                <Box sx={{ maxHeight: '100%', height: '90%', overflowY: 'auto', mt: 2 }}>
                    <iframe
                        srcDoc={content}
                        title="HTML Preview"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                    />
                </Box>
            </Box>
        </Modal>
    );
};

export default TemplatePreview;